import { BehaviorSubject } from "rxjs";

export const ScorecardSubject = new BehaviorSubject("");
